export default __webpack_public_path__ + "digital-performer.8a3b02c2.png";